import React, { Component } from "react";
import PropTypes from "prop-types";

export default class ColorMapImagePreview extends Component {

    shouldComponentUpdate(nextProps) {
        if (nextProps.imageNew !== this.props.imageNew) {
            return true;
        } else {
            return false;
        }
    }

  render() { 
      const { imageNew, } = this.props;

      const PicturePreview = () => {
          return <img className="imgColorMap" src={imageNew} height="100%" alt="Color Map" />;
      }

      return (
          <PicturePreview /> 
       );
  }
};

ColorMapImagePreview.propTypes = {
    imageNew: PropTypes.string,
};
